import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import Navbar from "./components/screens/Navbar";
import ActiveLocations from "./components/screens/ActiveLocations";
import AirportLayout from "./components/screens/AirportLayout";
import ShuttleIdentification from "./components/screens/ShuttleIdentification";
import RequestTracking from "./components/screens/RequestTracking";
import RequestVehicle from "./components/screens/RequestVehicle";
import User from "./components/screens/user/User";
import Dashboard from "./components/screens/Dashboard";
import DashboardQR from "./components/screens/DashboardQR";
import Login from "./components/screens/login/Login";
import RolesSetup from "./components/screens/rolesSetup/RolesSetup";
import Report from "./components/screens/Report";
import ActiveLocationsExternal from "./components/screens/ActiveLocationsExternal";
import UploadReservationData from "./components/screens/UploadReservationData";
import { baseURL } from "./components/screens/backend_url";
import axios from "axios";
import notificationSound from "./components/screens/assets/notification.mp3"; // Ensure to add a sound file

function App() {
  const [loginSuccess, setLoginSuccess] = useState(false);
  const [moduleDetail, setModuleDetail] = useState([]);
  const [moduleDetailHash, setModuleDetailHash] = useState({});
  const url = window.location.href;

  const [locationId, setLocationId] = useState("");
  const [userAccess, setUserAccess] = useState("");
  const [userAccessOG, setUserAccessOG] = useState({});
  const [newTicketCount, setNewTicketCount] = useState(0);

  const [allTickets, setAllTickets] = useState([]);

  // const playNotificationSound = () => {
  //   const audio = new Audio(notificationSound);
  //   audio.play().catch((error) => {
  //     console.error("Failed to play sound:", error);
  //   });
  // };

  const playNotificationSound = (count = 5) => { // Added count parameter
    if (count > 0) {
      const audio = new Audio(notificationSound);
      audio.play().catch((error) => {
        console.error("Failed to play sound:", error);
      });
      setTimeout(() => playNotificationSound(count - 1), 2000); // Play again after 2 second
    }
  };

  // Fetch tickets
  const [previousTickets, setPreviousTickets] = useState([]); // New state to track previous tickets

  const fetchTickets = async () => {
    const loggedInUser = sessionStorage.getItem("user_token");
    const foundUser = JSON.parse(loggedInUser);
    try {
      const response = await axios.get(
        baseURL + "/srt_get_requested_tickets_driver/" + foundUser.userEmail
      );
      const tickets = response.data;

      setAllTickets(tickets);
    } catch (error) {
      console.error("Failed to fetch tickets:", error);
    }
  };

  // Check for new tickets whenever allTickets changes
  useEffect(() => {
    if (allTickets.length > 0) {
      const newTickets = allTickets.filter(
        (ticket) => !previousTickets.some((t) => t._id === ticket._id) // Check based on unique _id
      );

      if (newTickets.length > 0) {
        const openTickets = allTickets.filter(ticket => ticket.ticket_status === true);
        setNewTicketCount(openTickets.length); // Update the count in App component
        playNotificationSound();
      }
    }
    setPreviousTickets(allTickets);
  }, [allTickets]); // Dependency array includes allTickets

  useEffect(() => {
    // Check if URL has "QR_Code"
    if (url.includes("QR_Code")) {
      const urlParts = url.split("?");
      if (urlParts.length > 1) {
        const searchParams = new URLSearchParams(urlParts[1]);
        const locationValue = searchParams.get("location");
        setLocationId(locationValue);
        console.log("Location value:", locationValue);
      }
    }
    const loggedInUser = sessionStorage.getItem("user_token");
    const foundUser = JSON.parse(loggedInUser);

    setUserAccess(foundUser?.role);
    setUserAccessOG(foundUser?.access);

    axios.get(baseURL + "/get_srt_modules").then((res) => {
      const loggedInUser1 = sessionStorage.getItem("user_token");
      if (loggedInUser1) {
        setLoginSuccess(true);
      }

      let temp_hash = {};
      
      const temp_module_arr = res.data.map((val) => {
        let temp_mod_name = val.name.toString().trim();
        if (temp_mod_name.indexOf(" ") > -1) {
          let t1_split = temp_mod_name.split(" ");
          if (t1_split.length > 0) {
            temp_mod_name = "";
            for (let i1 = 0; i1 < t1_split.length; i1++) {
              temp_mod_name += t1_split[i1];
            }
          }
        }

        if (temp_mod_name === "Dashboard")
          temp_hash[temp_mod_name] = <Dashboard />;
        else if (temp_mod_name === "ActiveLocations")
          temp_hash[temp_mod_name] = <ActiveLocations />;
        else if (temp_mod_name === "DesignatedPickUpPoints")
          temp_hash[temp_mod_name] = <AirportLayout />;
        else if (temp_mod_name === "ShuttleIdentification")
          temp_hash[temp_mod_name] = <ShuttleIdentification />;
        else if (temp_mod_name === "RequestTracking")
          temp_hash[temp_mod_name] = <RequestTracking />;
        else if (temp_mod_name === "DriverApp")
          temp_hash[temp_mod_name] = <RequestVehicle />;
        else if (temp_mod_name === "User") temp_hash[temp_mod_name] = <User />;
        else if (temp_mod_name === "AccessSetup")
          temp_hash[temp_mod_name] = <RolesSetup />;
        else if (temp_mod_name === "Report")
          temp_hash[temp_mod_name] = <Report />;
        else if (temp_mod_name === "ExternalLocations")
          temp_hash[temp_mod_name] = <ActiveLocationsExternal />;
        else if (temp_mod_name === "UploadReservationData")
          temp_hash[temp_mod_name] = <UploadReservationData />;

        return temp_mod_name;
      });

      if (
        foundUser?.role === "Users" ||
        (foundUser?.role === "SuperAdmin" &&
          foundUser?.role2 !== undefined &&
          foundUser?.role2 === "Admin")
      ) {
        axios
          .post(baseURL + "/get_srt_individual_user_details", {
            user_email: foundUser.userEmail,
          })
          .then((res1) => {
            let accnt = foundUser.account_id;

            axios
              .post(baseURL + "/get_srt_user_role_detail_db", {
                user_role: res1.data[0].selected_role,
                account_id: accnt.toString(),
              })
              .then((res2) => {
                res2.data[0].role_definition["MyProfile_Access Specifier"] =
                  "Edit";

                const tempMenuItems = temp_module_arr.filter((val) => {
                  if (
                    res2.data[0].role_definition[val + "_Access Specifier"] ===
                      "Edit" ||
                    res2.data[0].role_definition[val + "_Access Specifier"] ===
                      "View"
                  ) {
                    return val;
                  }
                });

                setModuleDetailHash(temp_hash);
                setModuleDetail(tempMenuItems);
              });
          });
      } else if (foundUser?.role === "SuperAdmin") {
        setModuleDetailHash(temp_hash);
        setModuleDetail(temp_module_arr);
      }

      const loggedInUser1_2 = JSON.parse(loggedInUser1);
      if (loggedInUser1_2?.role === "Users") {
        fetchTickets();

        // Set up polling to fetch tickets every 60 seconds
        const interval = setInterval(fetchTickets, 30000);
  
        return () => {
          clearInterval(interval); // Clean up on component unmount
        };
      }
    });
  }, []);

  return (
    <Router>
      {locationId !== "" ? (
        <>
          <DashboardQR locationId={locationId} />
        </>
      ) : (
        <>
          {loginSuccess && (
            <Navbar
              setLoginSuccess={setLoginSuccess}
              loginSuccess={loginSuccess}
              newTicketCount={newTicketCount}
              setNewTicketCount={setNewTicketCount}
              allTickets={allTickets}
            />
          )}

          <Routes>
            {!loginSuccess ? (
              <Route
                exact
                path="/Shuttle_Tracking/"
                element={<Login setLoginSuccess={setLoginSuccess} />}
              />
            ) : (
              <>
                {userAccess !== undefined &&
                userAccess === "Users" &&
                userAccessOG["DriverApp_Access Specifier"] != undefined &&
                userAccessOG["DriverApp_Access Specifier"] === "Edit" ? (
                  <Route
                    path="*"
                    element={<Navigate to="/Shuttle_Tracking/DriverApp" />}
                  />
                ) : userAccess !== undefined &&
                  userAccess === "Users" &&
                  userAccessOG["UploadReservationData_Access Specifier"] !=
                    undefined &&
                  userAccessOG["UploadReservationData_Access Specifier"] ===
                    "Edit" ? (
                  <Route
                    path="*"
                    element={
                      <Navigate to="/Shuttle_Tracking/UploadReservationData" />
                    }
                  />
                ) : (
                  <Route
                    exact
                    path="/Shuttle_Tracking/"
                    element={<Dashboard />}
                  />
                )}
                {moduleDetail.length > 0 &&
                  moduleDetail.map((val) => {
                    if (val === "DriverApp") {
                      return (
                        <Route
                          key={val}
                          exact
                          path={"/Shuttle_Tracking/" + val}
                          element={React.cloneElement(moduleDetailHash[val], 
                            {
                            setNewTicketCount: setNewTicketCount,
                            allTickets: allTickets,
                            setAllTickets: setAllTickets
                          }
                        )}
                        />
                      );
                    }
                    return (
                      <Route
                        key={val}
                        exact
                        path={"/Shuttle_Tracking/" + val}
                        element={moduleDetailHash[val]}
                      />
                    );
                  })}
              </>
            )}
          </Routes>
        </>
      )}
    </Router>
  );
}

export default App;
